import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { pick, omit, cloneDeep, get } from 'lodash';
import { toast } from '../../../common/toast';
import { popupActions } from '../../../../store/popupStore';
import { SECTIONS, reportActions } from '../../../../store/reportStore';
import { domainActions } from '../../../../store/domainStore';
import { object as YupObject } from '../../../common/Yup';
import { writeErr, writeWarn } from '../../../common/logger';
import { apiPost, apiDelete, getHostApi } from '../../../../store/apiWrapper';
import { isFunction, isNullOrUndefined, isString, isEmpty } from '../../../../store/storeFunctions';
import { repiActions, dataCorrectionAction, dataCorrectionSection, dataCorrectionType, listDefaultValues } from '../../../../store/repiStore';
import Paging from '../../../common/pagingComponent';

import Remove from '../../../../img/icons/BBiconsOdstranit';
import Warning from '../../../../img/icons/Warning';

import '../../repi.scss';

const CHECKBOXES = ["isIdentification", "flagActual", "isAnonymized", "isContractOpen"];

class RepiDataCorrectionTable extends React.Component {
    mounted = false;

    state = {
        data: [],
        inserted: {},
        page: 1,
        updatedOn: this.props.updatedOn,
        enableDateReinitialize: false
    };

    get children() {
        return React.Children.toArray(this.props.children).filter(f => !isNullOrUndefined(f));
    }

    render() {
        const { sectionId, contractId } = this.props;
        if (isNullOrUndefined(sectionId))
            return null;

        return (
            <Formik
                enableReinitialize
                ref={(el) => this.formRef = el}
                validateOnChange
                validationSchema={this.generateValidationSchema()}
                initialValues={this.getInitialValues()}>
                {({ values, setFieldValue, setValues, errors }) => <Form>
                    <div className={classnames("repi-data-correction-subsection", { "stretched": this.props.stretched === true })}>
                        {!isNullOrUndefined(contractId) && this.renderFakeButton("delete", () => this.onDeleteContract())}
                        {this.renderFakeButton("insert", () => this.onInsert(values, setValues))}
                        {this.renderFakeButton("save", () => this.onSave(values, setValues), this.hasErrors(errors))}
                        {this.renderFakeButton("cancel", () => this.onCancel(setValues))}
                        <table className="repi-data-correction-table fixed">
                            <thead>
                                <tr>
                                    {this.children.map(ch => React.cloneElement(ch, { isHeader: true, sectionId: sectionId }))}
                                    <td className="repi-data-correction-table-header-cell narrow" />
                                </tr>
                            </thead>
                            <tbody>
                                {this.getRows(values).filter(f => values[f].action !== dataCorrectionAction.delete).map((k) => <tr
                                    key={`${sectionId}-row-${k}`}
                                    {...this.getInternalRowProps(values[k])}
                                    className={classnames("repi-data-correction-table-row", {
                                        "pending-new": values[k].isPending === true
                                    })}
                                >
                                    {this.children.map(ch =>
                                        React.cloneElement(ch, {
                                            rowId: k,
                                            sectionId: sectionId,
                                            value: get(values, `${k}.${ch.props.name}`, ""),
                                            error: get(errors, `${k}.${ch.props.name}`, null),
                                            isNew: values[k].action === dataCorrectionAction.insert,
                                            isPending: values[k].isPending === true,
                                            setFieldValue: setFieldValue,
                                            enableDateReinitialize: this.state.enableDateReinitialize,
                                            afterDateReinitialized: () => this.setState({ enableDateReinitialize: false }),
                                            contractId: this.props.contractId
                                        })
                                    )}
                                    <td className="right" style={{ verticalAlign: "middle" }}>
                                        {<div>
                                            {(this.hasPendingRequests(values[k]) || values[k].isPending === true) && <span
                                                className={classnames("ml-link update-warning", { "no-pointer": values[k].isPending === true })}
                                                onClick={values[k].isPending !== true ? () => this.onShowUpdates(values[k]) : undefined}
                                            >
                                                <Warning className="ml-link-icon" />
                                            </span>}
                                            <span className="m-right-btn">
                                                <div className="ml-link color">
                                                    <div className="ml-link-inner">
                                                        {this.renderDeleteContractRowButton(k, values, setFieldValue, setValues)}
                                                    </div>
                                                </div>
                                            </span>
                                        </div>}
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>
                        {this.renderPaging(values)}
                    </div>
                </Form>}
            </Formik>
        );
    }

    componentDidMount() {
        if (!this.mounted && !isNullOrUndefined(this.props.data)) {
            let pendingData = [];
            if (!isNullOrUndefined(this.props.pendingData))
                pendingData = cloneDeep(this.props.pendingData).map(x => ({ ...x, isPending: true, action: "" }));
            this.setState({ data: [...cloneDeep(this.props.data.map(x => ({ ...x, isPending: false, action: "" }))), ...pendingData] });
        }
        this.mounted = true;
    }

    renderFakeButton = (action, callback, disabled) => {
        const { rowIndex } = this.props;

        return (
            <button
                id={`btn-${this.props.sectionId}${(isNullOrUndefined(rowIndex) ? "" : `-${rowIndex}`)}-${action}`}
                type="button"
                style={{ display: "none" }}
                onClick={isFunction(callback) ? callback : () => null}
                disabled={disabled === true}
            >
                {action}
            </button>
        );
    }

    renderDeleteContractRowButton = (k, values, setFieldValue, setValues) => {
        const isPending = values[k].isPending === true;
        const hasDeleteRequest = values[k].deleteRequest === true;
        const hasUpdateRequest = Array.isArray(values[k].updateRequests) && values[k].updateRequests.length > 0;
        const isPrimaryAddress = this.props.sectionId === dataCorrectionSection.identification && values[k].id === -1

        if (hasDeleteRequest || hasUpdateRequest || isPending || isPrimaryAddress) {
            return (
                <span className='link-internal is-disabled'>
                    <Remove className="ml-link-icon" />
                    <Translate id="Common.Button.Delete" />
                </span>
            )
        }
        
        return (
            <a className='link-internal' onClick={() => this.onDelete(k, values, setFieldValue, setValues)}>
                <Remove className="ml-link-icon" />
                <Translate id="Common.Button.Delete" />
            </a>
        )
    }

    renderPaging = (values) => {
        if (isNullOrUndefined(this.props.pageLimit) || this.props.pageLimit <= 0)
            return null;

        const keys = Object.keys(values);
        const totalPages = Math.ceil(keys.length / this.props.pageLimit).toFixed();
        if (totalPages < 2)
            return null;

        return (
            <div className="result-paging hide-on-mobile" style={{ marginTop: "0.75em" }}>
                <Paging
                    style={{ fontSize: "0.875em" }}
                    justify="center"
                    selectedPage={this.state.page}
                    totalPages={totalPages}
                    setPage={(page) => this.setState({ page: page })}
                />
            </div>
        );
    }

    getRows = (values) => {
        const keys = Object.keys(values).sort(this.sortRows);
        if (isNullOrUndefined(this.props.pageLimit) || this.props.pageLimit <= 0)
            return keys;
        if (keys.length <= this.props.pageLimit)
            return keys;

        const startIndex = (this.state.page - 1) * this.props.pageLimit;
        return keys.slice(startIndex, startIndex + this.props.pageLimit);
    }

    sortRows = (a, b) => {
        if (a.startsWith("N") && !b.startsWith("N"))
            return -1;
        if (!a.startsWith("N") && b.startsWith("N"))
            return 1;
        if (!a.startsWith("N") && !b.startsWith("N")) {
            const a1 = parseInt(a)
            const b1 = parseInt(b)

            if (!isNaN(a1) && !isNaN(b1))
                return a1 < b1 ? -1 : a1 === b1 ? 0 : 1

            return a.localeCompare(b);
        }
        if (a.startsWith("N") && b.startsWith("N")) {
            const a1 = parseInt(a.substring(1))
            const b1 = parseInt(b.substring(1))

            if (!isNaN(a1) && !isNaN(b1))
                return a1 < b1 ? 1 : a1 === b1 ? 0 : -1 // Inverted values

            return -a.localeCompare(b);
        }

        return 0;
    }

    getInternalRowProps = (values) => {
        if (!this.props.isDataCorrection(true))
            return {};

        const { idKey, secondaryIdKey } = this.props;
        const props = {};

        if (!isNullOrUndefined(idKey) && isString(idKey))
            props[`data-${idKey.toLowerCase()}`] = values[idKey];
        if (!isNullOrUndefined(secondaryIdKey) && isString(secondaryIdKey)) {
            const val2 = values[secondaryIdKey];
            props[`data-${secondaryIdKey.toLowerCase()}`] = isNullOrUndefined(val2) || val2 === "" ? "none" : val2;
        }

        return props;
    }

    onInsert = (values, setValues) => {
        const newRow = this.generateNewRow();
        const id = `N${-newRow[this.props.idKey]}`;
        this.setState({ inserted: { ...this.state.inserted, [id]: newRow } }, () => setValues({ ...this.state.inserted, ...values }));
    }

    onDelete = (rowId, values, setFieldValue, setValues) => {
        if (Object.keys(this.state.inserted).includes(rowId))
            this.setState({ inserted: omit(this.state.inserted, [rowId]) }, () => setValues({ ...omit(values, [rowId]) }));
        else
            setFieldValue(`${rowId}.action`, dataCorrectionAction.delete);
    }

    onCancel = (setValues) => {
        this.setState({ inserted: {}, enableDateReinitialize: true }, () => setValues(this.getInitialValues()));
    }

    onSave = (values, setValues) => {
        this.props.showPopup("repiConfirmDataCorrectionPopup", {
            title: this.props.translate("Repi.Report.DataCorrection.SaveChanges.Title"),
            htmlBody: this.getSaveConfirmationBody(),
            yesButtonText: this.props.translate("Common.Button.Save"),
            yesButtonFunction: (onLeave) => this.onSaveConfirmed(values, setValues, onLeave),
            noButtonText: this.props.translate("Common.Button.Cancel"),
            noButtonVisible: true,
            open: true,
            close: () => this.props.hidePopup(),
        });
    }

    onSaveConfirmed = (values, setValues, onLeave) => {
        const toSubmit = Object.values(values).filter(f => !isNullOrUndefined(f.action) && f.action.length > 0)

        const action = this.getSaveAction();
        if (isNullOrUndefined(action)) {
            writeErr(`No save action found for ${this.props.sectionId}`);
            if (isFunction(onLeave))
                onLeave()
            this.props.hidePopup();
            return;
        }

        const data = {
            subjectId: this.props.subjectId,
            isInternal: this.props.isDataCorrection(true),
            data: this.prepareDataToSubmit(toSubmit)
        };

        // Get contract header data (startDate, ednDate), consider "" as valid value and turn it to null
        if (!isNullOrUndefined(this.props.contractId)) {
            data.contractId = this.props.contractId;
            const dc = this.props.dataCorrection[this.props.contractId];

            if ((!dc.startDateIsValid && dc.startDate !== "") || (!dc.endDateIsValid && dc.endDate !== "")) {
                toast(this.props.translate("Repi.Error.Validation.ContractHeader"), "error");
                this.props.hidePopup();
                return;
            }

            if (!isNullOrUndefined(dc)) {
                if (dc.startDateChanged) {
                    data.startDate = dc.startDate === "" ? null : moment(dc.startDate, ["DD.MM.YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                    data.startDateSpecified = true;
                }
                if (dc.endDateChanged) {
                    data.endDate = dc.endDate === "" ? null : moment(dc.endDate, ["DD.MM.YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                    data.endDateSpecified = true;
                }
                data.updatedOn = this.state.updatedOn;
            }
        }

        if ((data.data === null || data.data.length === 0) && (isNullOrUndefined(this.props.contractId))) {
            toast(this.props.translate("Repi.Report.DataCorrection.NoDataToUpdate"), "info");
            if (isFunction(onLeave))
                onLeave()
            this.props.hidePopup();
            return;
        }

        apiPost(`${getHostApi()}/api/repi/data-correction/${action}`, null, data,
            (s) => this.evaluateResponse(s, (d) => {
                if (isNullOrUndefined(this.props.contractId)) {
                    const currentData = isNullOrUndefined(get(d, "data.data.data")) ? [] : d.data.data.data;
                    const pendingData = isNullOrUndefined(get(d, "data.data.insertedData")) ? [] : d.data.data.insertedData;
                    this.setState({
                            data: [
                                ...cloneDeep(currentData || []).map(x => ({ ...x, isPending: false, action: "" })),
                                ...cloneDeep(pendingData || []).map(x => ({ ...x, isPending: true, action: "" }))
                            ],
                            inserted: {}
                        },
                        () => {
                            setValues(this.getInitialValues());
                            toast(this.props.translate("Repi.Report.DataCorrection.RequestSuccess"), "success");
                        }
                    );
                } else {
                    const payments = isNullOrUndefined(d.data.data) || d.data.data.length === 0 ? [] : d.data.data[0].payments;
                    const pending = isNullOrUndefined(d.data.data) || d.data.data.length === 0 ? [] : d.data.data[0].insertedPayments;
                    this.setState({
                            data: [...cloneDeep(payments || []), ...cloneDeep(pending || []).map(x => ({ ...x, isPending: true, action: "" }))],
                            inserted: {},
                            updatedOn: d.data.updatedOn
                        },
                        () => {
                            setValues(this.getInitialValues());
                            this.props.updateContractHeaderData(this.props.contractId, {
                                startDate: d.data.startDate,
                                startDateChanged: false,
                                startDateIsValid: true,
                                endDate: d.data.endDate,
                                endDateChanged: false,
                                endDateIsValid: true
                            });
                            toast(this.props.translate("Repi.Report.DataCorrection.RequestSuccess"), "success");
                        }
                    );
                }
            }),
            (e) => {
                writeErr(e);
                toast(this.props.translate("Repi.Report.DataCorrection.RequestFailed"), "error");
            },
            (_) => {
                if (isFunction(onLeave))
                    onLeave()
                this.props.hidePopup();
            }
        );
    }

    onDeleteContract = () => {
        this.props.showPopup("confirmationPopup", {
            title: this.props.translate("Repi.Report.DataCorrection.DeleteContract.Title"),
            htmlBody: this.props.translate("Repi.Report.DataCorrection.DeleteContract.Body").replace("{0}", this.props.contractId),
            yesButtonText: this.props.translate("Common.Button.Delete"),
            yesButtonFunction: () => this.onDeleteContractConfirmed(),
            noButtonText: this.props.translate("Common.Button.Cancel"),
            noButtonVisible: true,
            open: true,
            close: () => this.props.hidePopup(),
        });
    }

    onDeleteContractConfirmed = () => {
        apiDelete(`${getHostApi()}/api/repi/data-correction/delete-contract`, null,
            { contractId: this.props.contractId, updatedOn: this.state.updatedOn },
            (s) => this.evaluateResponse(s, (_) => this.props.requestFetchSection([SECTIONS.repiReportPaymentHistory])),
            (e) => {
                writeErr(e);
                toast(this.props.translate("UnhappyUser.InternalServerError"), "error");
            },
            (_) => this.props.hidePopup()
        );
    }

    onShowUpdates = (values) => {
        this.props.showPopup("repiDataCorrectionUpdatesPopup", {
            title: this.props.translate("Repi.Report.DataCorrection.PendingRequests"),
            open: true,
            close: () => this.props.hidePopup(),
            data: {
                values: values,
                elements: this.props.children,
                sectionId: this.props.sectionId
            }
        });
    }

    evaluateResponse = (s, onSuccess) => {
        if (!isNullOrUndefined(s.error)) {
            writeErr(s.error);
            toast(this.props.translate("UnhappyUser.InternalServerError"), "error");
        } else if(s.hasData && !isNullOrUndefined(s.data) && !isNullOrUndefined(s.data.error)) {
            writeErr(s.data.error);
            toast(this.props.translate("UnhappyUser.InternalServerError"), "error");
        } else if (!s.hasData || isNullOrUndefined(s.data) || isEmpty(s.data)) {
            writeErr("No data returned");
            toast(this.props.translate("Repi.Report.DataCorrection.NoDataReturned"), "error");
        } else {
            if (isFunction(onSuccess))
                onSuccess(s);
        }
    }

    getInitialValues = () => {
        var data = this.state.data.map(d => this.normalizeValues({ ...pick(d, this.getFields()), action: "", product: this.props.product }));
        var x = Object.assign({}, data);
        return x;
    }

    getValue = (values, rowId, name, suppressWarnings = false) => {
        try {
            return values[rowId][name];
        } catch {
            if (suppressWarnings !== true)
                writeWarn(`Value not found ${this.props.sectionId}.${rowId}.${name}`);
            return null;
        }
    }

    generateNewRow = () => {
        let id = Math.max(...Object.keys(this.state.inserted).map(k => parseInt(k.slice(1))));
        if (isNaN(id) || !isFinite(id))
            id = 0;

        const row = {};
        this.getFields().forEach(f => {
            row[f] = CHECKBOXES.includes(f) ? false : "";
            if (Object.keys(listDefaultValues).includes(f))
                row[f] = listDefaultValues[f];
        });

        row[this.props.idKey] = -(id + 1);
        row.action = dataCorrectionAction.insert;
        row.subjectId = this.getSubjectId() || "";

        return row;
    }

    getSubjectId = () => {
        try {
            return isNullOrUndefined(this.props.subjectId)
                ? this.props.sections[0].data.subjectId
                : this.props.subjectId
        } catch {
            writeWarn("Could not get SubjectId from subject identification section");
            return null;
        }
    }

    normalizeValues = (values) => {
        Object.keys(omit(values, "updateRequests")).forEach(k => {
            if (isNullOrUndefined(values[k]))
                values[k] = CHECKBOXES.includes(k) ? false : "";
            if (Object.keys(listDefaultValues).includes(k))
                values[k] = this.getListValue(k, values[k]);
        });

        return values;
    }

    getSaveAction = () => {
        switch (this.props.sectionId) {
            case dataCorrectionSection.identification:
                return "update-identification";
            case dataCorrectionSection.contacts:
                return "update-contacts";
            case dataCorrectionSection.addresses:
                return "update-addresses";
            case dataCorrectionSection.documents:
                return "update-documents";
            case dataCorrectionSection.contracts:
                return "update-contract";
            default:
                return null;
        }
    }

    prepareDataToSubmit = (data) => {
        if (data.length === 0)
            return [];

        const floatCols = this.children.filter(f => f.props.type === dataCorrectionType.float).map(x => x.props.name);
        const intCols = this.children.filter(f => f.props.type === dataCorrectionType.int).map(x => x.props.name);

        data = data.map(d => {
            Object.keys(d).forEach(k => {
                if (Object.keys(listDefaultValues).includes(k)) {
                    if (k === "dunningLevel" && d[k] === listDefaultValues[k])
                        d[k] = null
                    else
                        d[k] = this.getListValue(k, d[k])
                }
                if (floatCols.includes(k)) {
                    const fTmp = parseFloat(d[k]);
                    d[k] = isNullOrUndefined(fTmp) || isNaN(fTmp) ? null : fTmp;
                }
                if (intCols.includes(k)) {
                    const iTmp = parseInt(d[k]);
                    d[k] = isNullOrUndefined(iTmp) || isNaN(iTmp) ? null : iTmp;
                }
                if (isNullOrUndefined(d[k]) || d[k] === "")
                    d[k] = null;
            });
            return d;
        });

        return data;
    }

    getSaveConfirmationBody = () => {
        switch (this.props.sectionId) {
            case dataCorrectionSection.identification:
                return this.props.translate("Repi.Report.DataCorrection.SaveChanges.Body.Identifications");
            case dataCorrectionSection.contacts:
                return this.props.translate("Repi.Report.DataCorrection.SaveChanges.Body.Contacts");
            case dataCorrectionSection.addresses:
                return this.props.translate("Repi.Report.DataCorrection.SaveChanges.Body.Addresses");
            case dataCorrectionSection.documents:
                return this.props.translate("Repi.Report.DataCorrection.SaveChanges.Body.Documents");
            case dataCorrectionSection.contracts:
                let contractName = this.props.translate(`Repi.Report.PaymentHistory.Filter.ContractType.${this.props.product}`);
                contractName = this.props.isDataCorrection(true) ? `${contractName} (ID: ${this.props.contractId})` : contractName;
                return this.props.translate("Repi.Report.DataCorrection.SaveChanges.Body.Contract").replace("{0}", contractName);
            default:
                return "-";
        }
    }

    getListValue = (k, v) => {
        if (isNullOrUndefined(v) || v === "")
            return listDefaultValues[k];
        const parsed = parseInt(v);
        return isNaN(parsed) ? listDefaultValues[k] : parsed;
    }

    getFields = () =>{
        const primaryFields = [this.props.idKey, "subjectId", "action", "isPending", "updateRequests", "deleteRequest"];

        if (!isNullOrUndefined(this.props.secondaryIdKey))
            primaryFields.push(this.props.secondaryIdKey);

        if (isNullOrUndefined(this.props.updatedOnKeys) || !Array.isArray(this.props.updatedOnKeys))
            primaryFields.push("updatedOn");
        else
            this.props.updatedOnKeys.forEach(u => primaryFields.push(u));

        return [...primaryFields, ...this.children.map(c => c.props.name)];
    }

    generateValidationSchema = () => {
        let schema = {};

        if (!isNullOrUndefined(this.props.validationSchema) && Object.keys(this.props.validationSchema).length > 0) {
            for (let i = 0; i < this.state.data.length; ++i)
                schema[i.toString()] = YupObject().shape(this.props.validationSchema);
            Object.keys(this.state.inserted).forEach(k => schema[k] = YupObject().shape(this.props.validationSchema));
        }

        return YupObject().shape(schema);
    }

    hasPendingRequests = (values) => {
        if (isNullOrUndefined(values))
            return false;

        return (Array.isArray(values.updateRequests) && values.updateRequests.length > 0) || values.deleteRequest === true;
    }

    hasErrors = (formikErrors) => {
        const flat = this.flattenObject(formikErrors, 2);
        const filtered = Object.values(flat).filter(f => isString(f) || isNullOrUndefined(f.isWarning));
        return filtered.length > 0;
    }

    flattenObject = (obj, maxLevel = 10, keySeparator = '.') => {
        const flattenRecursive = (obj, parentProperty, propertyMap, currentLevel) => {
            for(const [key, value] of Object.entries(obj)) {
                const property = parentProperty ? `${parentProperty}${keySeparator}${key}` : key;
                if(currentLevel < maxLevel && value && typeof value === 'object')
                    flattenRecursive(value, property, propertyMap, currentLevel + 1);
                else
                    propertyMap[property] = value;
            }
            return propertyMap;
        };
        return flattenRecursive(obj, null, {}, 1);
    }
}

export default connect(
    state => ({ ...state.domain, ...state.report, ...state.popup, dataCorrection: { ...state.repi.dataCorrection } }),
    dispatch => bindActionCreators({ ...repiActions, ...domainActions, ...reportActions, ...popupActions }, dispatch)
)(withLocalize(RepiDataCorrectionTable));
